import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "columns is-centered is-mobile" }
const _hoisted_3 = { class: "column is-two-thirds" }
const _hoisted_4 = {
  class: "has-text-primary has-text-centered is-size-6 is-mobile",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_5 = { class: "level is-mobile pt-4" }
const _hoisted_6 = {
  key: 0,
  class: "level-item level-left"
}
const _hoisted_7 = {
  class: "has-text-primary is-size-5 is-mobile",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_8 = { class: "level-item level-right has-text-right" }
const _hoisted_9 = { class: "block pb-6" }
const _hoisted_10 = { class: "columns is-mobile" }
const _hoisted_11 = {
  key: 0,
  class: "card equipo-card"
}
const _hoisted_12 = { class: "card-image" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = {
  class: "has-text-primary is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_16 = {
  class: "is-size-6 has-text-green",
  style: {"font-family":"Calibri","font-weight":"bold"}
}

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMenuLeft, mdiMenuRight } from "@mdi/js";
import { Equipo, useEquipos } from "@/use-equipos";
import { ref } from "vue";
import { useWindowSize } from "vue-window-size";


export default /*#__PURE__*/_defineComponent({
  __name: 'EquiposCarrusel',
  props: {
    title: {},
    text: {},
    label: {},
    clasification: {}
  },
  setup(__props: any) {

const props = __props;

const { width } = useWindowSize();
const { getEquiposByClasificacion } = useEquipos();
const equipos = getEquiposByClasificacion(props.clasification);
const equiposSize = equipos.length;
const pages = Math.ceil(equiposSize / 3);
const currentPage = ref(1);
const equiposPage = ref(getEquiposPerPage(currentPage.value));

function getEquiposPerPage(page: number) {
  const initialPos = page === 1 ? 0 : page * 3 - 3;
  const finalPos = initialPos + 3 < equiposSize ? initialPos + 3 : equiposSize;
  let equiposArray = equipos.slice(initialPos, finalPos);
  const equiposLength = equiposArray.length;
  if (equiposLength < 3) {
    for (let index = 0; index < 3; index++) {
      const element = equiposArray[index];
      if (!element) {
        equiposArray.push({} as Equipo);
      }
    }
  }
  console.log(equiposArray);
  return equiposArray;
}

function nextPage() {
  currentPage.value = currentPage.value < pages ? currentPage.value + 1 : 1;
  equiposPage.value = getEquiposPerPage(currentPage.value);
}

function previousPage() {
  currentPage.value = currentPage.value > 1 ? currentPage.value - 1 : pages;
  equiposPage.value = getEquiposPerPage(currentPage.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 0,
            class: _normalizeClass(["has-text-centered has-text-primary pt-6 pb-4 is-mobile", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, _toDisplayString(_ctx.title), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.text), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.label), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(SvgIcon), {
            onClick: previousPage,
            class: "has-text-yellow",
            type: "mdi",
            path: _unref(mdiMenuLeft),
            style: {"width":"50px","height":"50px"}
          }, null, 8, ["path"]),
          _createVNode(_unref(SvgIcon), {
            onClick: nextPage,
            class: "has-text-yellow",
            type: "mdi",
            path: _unref(mdiMenuRight),
            style: {"width":"50px","height":"50px"}
          }, null, 8, ["path"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equiposPage.value, (equipo, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "column"
          }, [
            (equipo.img)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: equipo.img,
                      alt: equipo.alt
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(equipo.nombre), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(equipo.codigo), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})